<template>
  <ConfirmDialog group="actions" />
  <Dialog :visible="state.show && state.kind === 'prompt'" :header="state.title" modal :draggable="false" :style="{width:'min(440px, calc(100vw - 32px))'}" @update:visible="finishDialog(false)">
    <form @submit.prevent="finishDialog(true)" class="space-y-4">
      <InputText v-model="state.value" :aria-label="state.title" fluid autofocus required />
      <div class="dialog-actions"><Button label="ยกเลิก" severity="secondary" outlined @click="finishDialog(false)" /><Button label="บันทึก" type="submit" /></div>
    </form>
  </Dialog>
</template>
<script setup>
import { watch } from 'vue';
import { useToast } from 'primevue/usetoast';
import { useConfirm } from 'primevue/useconfirm';
import { dialogState as state, finishDialog } from '../dialog';
const toast = useToast(), confirm = useConfirm();
watch(() => state.show, visible => {
  if (!visible || state.kind === 'prompt') return;
  if (state.kind === 'notice') {
    toast.add({severity: state.tone === 'danger' ? 'error' : state.tone, summary: state.title, detail: state.message, life: state.tone === 'error' ? 8000 : 4000});
    finishDialog(true);
  } else confirm.require({group:'actions', header:state.title, message:state.message, icon:'pi pi-exclamation-circle', acceptLabel:state.confirmText, rejectLabel:'ยกเลิก', acceptProps:{severity:state.tone === 'danger' ? 'danger' : 'primary'}, rejectProps:{severity:'secondary',outlined:true}, accept:()=>finishDialog(true), reject:()=>finishDialog(false), onHide:()=>{if(state.show) finishDialog(false);}});
});
</script>
